import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Корзина", -1)
const _hoisted_2 = { class: "basket-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "basket-item-body" }
const _hoisted_5 = { class: "basket-item-title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "price"
}
const _hoisted_8 = {
  key: 0,
  class: "basket-item-addition"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Добавить:", -1)
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "count" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "item-price" }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = {
  key: 0,
  class: "added-info"
}
const _hoisted_18 = { class: "price" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_20 = { class: "actions" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "actions" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "count" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "item-price" }
const _hoisted_27 = { class: "price" }
const _hoisted_28 = {
  key: 0,
  class: "added-info"
}
const _hoisted_29 = { class: "price" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_31 = { class: "actions action-del" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "basket-sum"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Сумма заказа:", -1)
const _hoisted_35 = { class: "price" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Оформить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EmptyBasket = _resolveComponent("EmptyBasket")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBasketFullInfo, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "basket-item",
          key: key
        }, [
          _createElementVNode("img", {
            src: item.mealData.orderImgUrl,
            alt: "",
            class: "basket-item-img"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.changeDisplayedMealId(item.mealId)),
                class: "basket-item-name"
              }, _toDisplayString(item.mealData.name), 9, _hoisted_6),
              (Object.keys(item.additions).length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.mealData.price), 1))
                : _createCommentVNode("", true)
            ]),
            (Object.keys(item.additions).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.additionsData, (addition, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "basket-item-addition-item",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(addition.name), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "reduce",
                          onClick: ($event: any) => (_ctx.changeAdditionCount(item, idx, item.additions[idx] - 1))
                        }, null, 8, _hoisted_12),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.additions[idx]), 1),
                        _createElementVNode("div", {
                          class: "add",
                          onClick: ($event: any) => (_ctx.changeAdditionCount(item, idx, item.additions[idx] + 1))
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getAdditionsCost({ [idx]: item.additions[idx] })), 1),
                        (item.additions[idx] > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createTextVNode(" (" + _toDisplayString(item.additions[idx]) + " x ", 1),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getAdditionPrice(+idx)), 1),
                              _hoisted_19
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", {
                          class: "delete",
                          onClick: ($event: any) => (_ctx.deleteAddition(item, idx))
                        }, null, 8, _hoisted_21)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "reduce",
              onClick: ($event: any) => (_ctx.changeMealCount(item, item.count - 1))
            }, null, 8, _hoisted_23),
            _createElementVNode("span", _hoisted_24, _toDisplayString(item.count), 1),
            _createElementVNode("div", {
              class: "add",
              onClick: ($event: any) => (_ctx.changeMealCount(item, item.count + 1))
            }, null, 8, _hoisted_25)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getBasketItemCost(item)), 1),
            (item.count > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createTextVNode(" (" + _toDisplayString(item.count) + " x ", 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.getBasketItemCost(item) / item.count), 1),
                  _hoisted_30
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              class: "delete",
              onClick: ($event: any) => (_ctx.deleteItemInBasket(item.id))
            }, null, 8, _hoisted_32)
          ])
        ]))
      }), 128)),
      (_ctx.basketCost > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.basketCost), 1),
            _createVNode(_component_router_link, {
              to: { name: 'Ordering' },
              class: "btn-main"
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(_component_EmptyBasket, { key: 1 }))
    ])
  ]))
}